<script setup>
import ModalComponent from "@/components/ModalComponent.vue";
import useImportCourseHolesModal from "@/scripts/Utilities/Holes/ImportCourseHolesModal.js";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "import-holes"]);

const {
  targetCourse,
  selectedFile,
  fileName,
  isLoading,
  errorMessage,
  errorMessages,
  handleFileChange,
  handleImport,
  closeModal,
} = useImportCourseHolesModal(props, emit);
</script>

<template>
  <ModalComponent :modelValue="modelValue" @update:modelValue="closeModal">
    <template #header>
      <h5 class="modal-title">
        <i class="fas fa-file-import mr-2"></i> Import Course Holes
      </h5>
      <button type="button" class="close" @click="closeModal">
        <span>&times;</span>
      </button>
    </template>

    <template #default>
      <div class="col">
        <div class="col-12">
          <div class="form-group">
            <label>Selected course:</label>
            <div class="border border-secondary border-2 rounded p-2">
              {{ targetCourse.name }}
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="csvFile">CSV File</label>
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                id="csvFile"
                accept=".csv"
                @change="handleFileChange"
              />
              <label class="custom-file-label" for="csvFile">
                {{ fileName || "Choose file" }}
              </label>
            </div>
            <small class="form-text text-muted">
              Upload a CSV with hole data: hole numbers, par, colours,
              coordinates, etc.
            </small>
          </div>
        </div>

        <hr class="border border-secondary mt-3 mb-3" />

        <div class="text-danger col-12 mb-3" v-if="errorMessage">
          {{ errorMessage }}
        </div>

        <div v-if="errorMessages.length > 0" class="col-12">
          <h6>Import Holes Errors:</h6>

          <ul class="pl-3 text-danger overflow-auto" style="max-height: 250px">
            <li v-for="message in errorMessages" :key="message.message">
              {{ message.message }}
            </li>
          </ul>
        </div>
      </div>
    </template>

    <template #footer>
      <button type="button" class="btn btn-danger" @click="closeModal">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-success"
        @click="handleImport"
        :disabled="isLoading || !selectedFile"
      >
        <i class="fas fa-spin fa-spinner mr-1" v-if="isLoading"></i>
        Import
      </button>
    </template>
  </ModalComponent>
</template>

<style scoped>
.custom-file-label::after {
  content: "Browse";
}

.modal-title {
  display: flex;
  align-items: center;
}
</style>
